const getters = {
  token: state => state.user.token,
  userId: state => state.user.userId,
  userName: state => state.user.userName,
  nickName: state => state.user.nickName,
  roleId: state => state.user.roleId,
  operator: state => state.user.operator,
  avatar: state => state.user.avatar,
  isAdmin: state => state.user.isAdmin,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  sidebarRouters: state => state.permission.sidebarRouters,
  breadcrumb: state => state.permission.breadcrumb,
}
export default getters
